import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect, Route } from 'react-router-dom';
import Loading from '../Loading/Loading';

const AdminRoute = ({ component: Component, children, ...rest }) => {
  const currentUser = useSelector((state) => state.currentUser);
  const isAuthReady = useSelector((state) => state.auth.isAuthReady);

  if (!isAuthReady) {
    return <Loading />;
  }

  return (
    <Route
      {...rest}
      render={(props) => {
        // Check the `roles` object populated from the ID token claims.
        // The `?.` operator safely handles cases where `roles` might be undefined.
        if (currentUser && currentUser.roles?.admin === true) {
          // If children are provided, render them. Otherwise, render the component.
          // This makes the AdminRoute flexible for both patterns.
          return children ? children : <Component {...props} />;
        }
        return <Redirect to="/" />;
      }}
    />
  );
};

export default AdminRoute;
